import React from "react";

const ExclamationSquareIcon = (props: React.ComponentProps<"svg">) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.3335 1.33398H14.6668V13.0007C14.6668 13.9211 13.9206 14.6673 13.0002 14.6673H3.00016C2.07969 14.6673 1.3335 13.9211 1.3335 13.0007V1.33398Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="8"
      y="4.6665"
      width="0.00833333"
      height="0.00833333"
      stroke={props.fill || "#101820"}
      strokeWidth="2.5"
      strokeLinejoin="round"
    />
    <path
      d="M8 8V11.3333"
      stroke={props.fill || "#101820"}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ExclamationSquareIcon;
